import { Skeleton, Box, Grid, Paper } from "@mui/material";

export default function ComercialLoading() {
    return (
        <Grid container spacing={2} mt={2}>
            {/* Card de Ações rápidas */}
            <Grid size={{xs: 12, md: 4}}>
                <Paper sx={{ p: 2, height: 180 }}>
                    <Skeleton variant="text" width={140} height={32} sx={{ mb: 2 }} />
                    <Skeleton variant="rectangular" width="90%" height={24} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" width="90%" height={24} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" width="90%" height={24} />
                </Paper>
            </Grid>

            {/* Card de Pedidos de venda*/}
            <Grid size={{xs: 12, md: 8}}>
                <Paper sx={{ p: 2 }}>
                    <Skeleton variant="text" width={250} height={32} sx={{ mb: 2 }} />
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="text" width={60} height={20} />
                            <Skeleton variant="rectangular" width={30} height={36} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="text" width={100} height={20} />
                            <Skeleton variant="rectangular" width={30} height={36} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <Skeleton variant="text" width={110} height={20} />
                            <Skeleton variant="rectangular" width={30} height={36} />
                        </Grid>
                    </Grid>
                    <Box mt={2}>
                        <Skeleton variant="rectangular" width={220} height={36} />
                    </Box>
                </Paper>
            </Grid>

            {/* Card do gráfico e card dos principais compradores */}
            <Grid size={{xs: 12, md: 6}}>
                <Paper sx={{ p: 2, height: 370 }}>
                    <Skeleton variant="text" width={220} height={24} sx={{ mb: 2 }} />
                    <Skeleton variant="rectangular" width="100%" height={300} />
                </Paper>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Paper sx={{ p: 2, height: 370 }}>
                    <Skeleton variant="text" width={160} height={24} sx={{ mb: 2 }} />
                    {[...Array(8)].map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width="100%" height={28} sx={{ mb: 1 }} />
                    ))}
                    <Skeleton variant="rectangular" width="60%" height={28} />
                </Paper>
            </Grid>
        </Grid>
    );
}